import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MoviesPage from "../pages/movies/page";
import MovieDetailPage from "../pages/movie/page";
import CinemasPage from "../pages/cinemas/page";
import CinemaDetailPage from "../pages/cinema/page";
import ScheduleDetailPage from "../pages/schedule/page";
import NewsPage from "../pages/news/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/movies",
    element: <MoviesPage />,
  },
  {
    path: "/movie/:id",
    element: <MovieDetailPage />,
  },
  {
    path: "/cinemas",
    element: <CinemasPage />,
  },
  {
    path: "/cinema/:id",
    element: <CinemaDetailPage />,
  },
  {
    path: "/schedule/:id",
    element: <ScheduleDetailPage />,
  },
  {
    path: "/news",
    element: <NewsPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;